import base from "./base.service"

const termsPage = () => base.get('/pages/terms-conditions');
const privacyPage = () => base.get('/pages/privacy-policy');
const aboutPage = () => base.get('/pages/about-us');
const Faq = () => base.get('/pages/faqs');

export const pageService = {
    Faq,
    aboutPage,
    termsPage,
    privacyPage
}